import { NETWORK_CONSTANTS } from '@/lib/constants/network'
import { connectivityFetch } from '@/lib/connectivity/fetchMiddleware'

/**
 * Merge caller abort signals with a network timeout (whichever fires first).
 */
export function combineAbortSignals(signals: AbortSignal[]): AbortSignal {
  const active = signals.filter((signal): signal is AbortSignal => signal != null)
  if (active.length === 0) {
    return AbortSignal.timeout(NETWORK_CONSTANTS.SUPABASE_FETCH_TIMEOUT_MS)
  }
  if (active.length === 1) return active[0]!

  if (typeof AbortSignal.any === 'function') {
    return AbortSignal.any(active)
  }

  const controller = new AbortController()
  const abortFromAny = () => {
    const reason = active.find((signal) => signal.aborted)?.reason
    controller.abort(reason)
  }

  for (const signal of active) {
    if (signal.aborted) {
      abortFromAny()
      return controller.signal
    }
    signal.addEventListener('abort', abortFromAny, { once: true })
  }

  return controller.signal
}

/**
 * `fetch` wrapper used for all Supabase browser/edge clients and proxy middleware.
 * Delegates to {@link connectivityFetch} for timeout + connectivity state.
 */
export const fetchWithNetworkTimeout = connectivityFetch
